module.exports = __webpack_public_path__ + "static/media/big-neon-gif-1.741d6fce.gif";